/**
 * Input Schema of ResponsavelFilial
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'

/* TODO: review generated schema */
export class InputResponsavelFilialSchema extends Schema {
  readonly name = 'InputResponsavelFilial'

  readonly fieldSet: FieldSet<ResponsavelFilial> = {
    cnpjBase: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
